<template>
  <RevContainer>
    <ul class="flex flex-wrap gap-8 my-56">
      <li v-for="category in categories" :key="category.name">
        <RevLink :to="getCmsLinkByCategory(category.name)">
          <RevPill
            class="body-2 bg-action-default-hi text-onaction-default-hi hover:bg-action-default-hi-hover motion-safe:ease-in motion-safe:transition motion-safe:duration-300"
            :label="category.label"
            size="medium"
          />
        </RevLink>
      </li>
    </ul>
  </RevContainer>
</template>

<script setup lang="ts">
import {
  type BuybackCategory,
  useBuybackCategories,
} from '@backmarket/nuxt-layer-buyback/app/scopes/offer/composables/useBuybackCategories/useBuybackCategories'
import { RevContainer } from '@ds/components/Container'
import { RevLink } from '@ds/components/Link'
import { RevPill } from '@ds/components/Pill'

defineProps<{
  categories: BuybackCategory[]
}>()

const { getCmsLinkByCategory } = useBuybackCategories()
</script>
